import { murmurhash3_x64_128 } from './murmurhash3';

// RFC 9562 version 8 (vendor-defined) UUID carrying the 128-bit MurmurHash3 of the input, so the
// result still satisfies the branded uuid schemas. MurmurHash3 is not collision-resistant against
// chosen inputs; callers must confine the input space to ids the platform mints itself.
export const deterministicUuid = (input: string): string => {
  const [h1, h2] = murmurhash3_x64_128(input);
  const hex = h1.toString(16).padStart(16, '0') + h2.toString(16).padStart(16, '0');
  const variant = ((parseInt(hex[16], 16) & 0x3) | 0x8).toString(16);
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-8${hex.slice(13, 16)}-${variant}${hex.slice(17, 20)}-${hex.slice(20)}`;
};
